export default "__VITE_ASSET__Cl5$NIUa__"